







































import { Component, Vue, Mixins } from 'vue-property-decorator';
import { queryReportByViewId, getViewGroup } from '@/apis/sheet';
import sheetCommon from '../sheetCommon';
import chartView from './index';
@Component({
	name: 'chart',
	components: {
		chartView,
	},
})
export default class extends Mixins(sheetCommon) {
	public viewList: any[] = [];
	private loading = false;
	private finished = false;
	private activeIndex = ''; // 选中状态
	private viewData: any[] = [];
	private isView = false;
	private mounted() {
		const { viewId, worksheetId } = this.$route.params;
		this.activeIndex = viewId;
		this.getRecord(viewId);
		this.getViewGroup(worksheetId);
	}
	private async getRecord(viewId) {
		this.isView = true;
		const res = await queryReportByViewId(viewId);
		if (res.code === 200) {
			this.viewData = res.data || [];
			if (this.viewData.length === 0) {
				this.isView = false;
			}
		}
	}
	private async getViewGroup(viewId) {
		this.viewList = await this.searchFilterListReport(viewId);
	}
	/**
	 * 点击一级菜单
	 */
	private clickViewGroup(index) {
		this.viewList.forEach((item) => {
			if (item.id === index) {
				item.children ? this.viewReplace(item.children[0].id) : this.viewReplace(index);
			}
		});
	}
	/**
	 * 点击二级菜单
	 */
	private clickView(one) {
		this.viewReplace(one.id);
	}
	private viewReplace(id) {
		this.$router.replace(
			`/${this.$route.params.applicationId}/${this.$route.params.worksheetId}/chart/${id}`
		);
		this.getRecord(id);
	}
}
